<template>
  <div class="layout" :class="{ 'layout--collapsed': isCollapsed }">
    <!-- 侧边栏 -->
    <sidebar />
    <!-- 右侧主区域 -->
    <div class="layout__main">
      <app-header />
      <div class="layout__content">
        <router-view :key="$route.path" />
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from './Sidebar.vue'
import AppHeader from './Header.vue'

export default {
  name: 'Layout',
  components: {
    Sidebar,
    AppHeader
  },
  computed: {
    /**
     * 侧边栏是否折叠
     */
    isCollapsed() {
      return this.$store.state.app.sidebarCollapsed
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.layout {
  display: flex;
  width: 100%;
  height: 100%;
  overflow: hidden;

  &__main {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-width: 0;
    margin-left: $sidebar-width;
    transition: margin-left 0.3s;
  }

  &--collapsed &__main {
    margin-left: $sidebar-collapse-width;
  }

  &__content {
    flex: 1;
    overflow-y: auto;
    background-color: $page-bg;
    padding: 0;
  }
}
</style>
